import React from "react"
import { withRouter } from "next/router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuilding } from "@fortawesome/pro-light-svg-icons"
import Card from "../../common/components/Card"
import SocialImage from "../../common/components/SocialImage"
import { imageHandler } from "../../utilities/imageHandler"
import { LinkBox, LinkOverlay, Heading, Box, useTheme } from "@chakra-ui/react"
import useColors from "../../common/hooks/useColors"

const getResizedPopMedia = (popMedia) => {
  if (!popMedia?.url) {
    return popMedia
  }

  const url = imageHandler(popMedia?.url, {
    resize: { width: 300, fit: "cover" },
  })
  return { ...popMedia, url: url }
}

const imageHeight = "186px"

const GymCard = ({ gym, isDisabled = false }) => {
  const { blueColor } = useColors()
  return (
    <>
      <LinkBox as="article">
        <Card variant={isDisabled ? "" : "link"} overflow="hidden">
          {gym?.popMedia?.url ? (
            <Box m={-5} mb={3} height={imageHeight}>
              <SocialImage
                imageObj={getResizedPopMedia(gym.popMedia)}
                height="100%"
                width="100%"
              />
            </Box>
          ) : (
            <Box
              m={-5}
              mb={3}
              height={imageHeight}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <FontAwesomeIcon color={blueColor} icon={faBuilding} size="5x" />
            </Box>
          )}
          <LinkOverlay href={"/gyms/" + gym.slug}>
            <Heading variant="link" as="h3" size="md" mb={0}>
              {gym.name}
            </Heading>
          </LinkOverlay>
        </Card>
      </LinkBox>
    </>
  )
}

export default withRouter(GymCard)
